
import { useCatalogPageContext } from "shared/catalog/CatalogPageContext/useCatalogPageContext";

import { CatalogGrid } from "../CatalogGrid";

import { CatalogProductCardLegacy } from "./CatalogProductCardLegacy";


export const LegacyCatalog = () => {
  const { legacyEntries } = useCatalogPageContext();

  return (
    <CatalogGrid>
      {legacyEntries?.map((product) => (
        <CatalogProductCardLegacy
          key={product.slug}
          brand={product.brand}
          slug={product.slug}
          modelName={product.entryName}
          image={product.picture}
        />
      ))}
    </CatalogGrid>
  );
};
